import type { CSSProperties, JSX } from 'react'

import sharedStyles from './chart-shared.module.css'

interface ChartColorDotProps {
  /** Swatch colour: a resolved colour or a `var()` token string. */
  color: string
  /** Render a dashed outline (comparison series) instead of a filled square. */
  dashed?: boolean
}

/**
 * Small colour swatch used in chart tooltips and legends — a filled square by
 * default, or a dashed outline for comparison overlays.
 */
export function ChartColorDot({
  color,
  dashed = false,
}: ChartColorDotProps): JSX.Element {
  const dotStyle: CSSProperties & { '--dot-color': string } = {
    '--dot-color': color,
  }
  return (
    <span
      className={`${sharedStyles.colorDot} ${
        dashed ? sharedStyles.colorDotDashed : sharedStyles.colorDotSquare
      }`}
      aria-hidden="true"
      style={dotStyle}
    />
  )
}
